var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisapprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.76L12 13.26L16.5 17.76L17.76 16.5L13.26 12L17.76 7.5L16.5 6.24L12 10.74L7.5 6.24L6.24 7.5L10.74 12L6.24 16.5L7.5 17.76ZM12 24C10.36 24 8.81 23.685 7.35 23.055C5.89 22.425 4.615 21.565 3.525 20.475C2.435 19.385 1.575 18.11 0.945 16.65C0.315 15.19 0 13.64 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.435 4.59 3.525 3.51C4.615 2.43 5.89 1.575 7.35 0.945C8.81 0.315 10.36 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.64 23.685 15.19 23.055 16.65C22.425 18.11 21.57 19.385 20.49 20.475C19.41 21.565 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 22.2C14.84 22.2 17.25 21.205 19.23 19.215C21.21 17.225 22.2 14.82 22.2 12C22.2 9.16 21.21 6.75 19.23 4.77C17.25 2.79 14.84 1.8 12 1.8C9.18 1.8 6.775 2.79 4.785 4.77C2.795 6.75 1.8 9.16 1.8 12C1.8 14.82 2.795 17.225 4.785 19.215C6.775 21.205 9.18 22.2 12 22.2Z",
    fill: "#EC1D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapprove);
export default __webpack_public_path__ + "static/media/disapprove.040cd1c6cb40869399abc96a60193215.svg";
export { ForwardRef as ReactComponent };